<ng-container *ngIf="lessonObservable | async; let lesson">
  <app-lesson-edit-nav [lesson]="lesson"></app-lesson-edit-nav>
  <section class="p-5 h-100">
  <mat-card [ngClass]=AppConfig.theme>
      <form class="w-100 title-form" (ngSubmit)="onSubmit(lesson)" (ngModelChange)="onSubmit(lesson)">
        <mat-form-field class="w-100">
          <input matInput [(ngModel)]="lesson.name" name="name" (ngModelChange)="onSubmit(lesson)">
        </mat-form-field>
      </form>
      <app-article-content class="py-3">
        <form class="w-100 mde-form" (ngModelChange)="onSubmit(lesson)">
            <simplemde-container appFileDrop (fileOver)="onFileOver($event)" (fileDrop)="onFileDrop($event)">
              <textarea appSimpleMDE (createMDE)="getSimpleMDE($event)" placeholder="내용" [(ngModel)]="lesson.content" name="content" (ngModelChange)="onSubmit(lesson)"></textarea>
            </simplemde-container>
        </form>
      </app-article-content>
    <mat-progress-bar *ngIf="!isUploaded" mode="indeterminate"></mat-progress-bar>
  </mat-card>
  </section>
</ng-container>



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson-edit/lesson-edit.component.html